export default "assets/images/logo_v-75aaaebf.png";